import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import { MdDelete } from "react-icons/md";
import { Link } from 'react-router-dom';
import { FaGear } from 'react-icons/fa6';
import AsignarUsuario from './AsignarUsuario';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'10%'}}>Posición</th>
        <th className='d-none d-sm-table-cell' style={{width:'20%'}}>Descripción posición</th>
        <th className='d-none d-sm-table-cell' style={{width:'2%'}}>Quitar</th>
        <th className='d-none d-sm-table-cell' style={{width:'15%'}}>Juez</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  
  if (props.listOfPosiciones) {
    
    const rows = props.listOfPosiciones.map((row, index) => { 

      return (      
        <tr key={index}>        
          <td>  
            {row["posicion"].nombreposicion}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row["posicion"].descripcionposicion}
          </td>  
          <td>
            <Button variant="secondary" onClick={() => props.delete(row.id)}><MdDelete /></Button>  
          </td> 
          {/*
          <td>
            <Button variant="secondary">
              <Link to = {`/editorganigramaareas/${row.id}`}><FaGear size={15} color='white'/></Link>      
            </Button>          
          </td> 
          */}
          <td>
            {/*{row.user?row.user.primerapellido + ", " + row.user.primernombre:null}  */}
            <AsignarUsuario 
              id={row.id} 
              organigramaareasid={row.id} 
              area={row.posicion}
              user={row.user}
              posicion={true}
              organigrama={props.organigrama}
            />              
          </td>           
                                     
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}
const CompetenciaPosicionesList = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody 
              mode={props.mode} 
              onSelected={props.onSelected} 
              listOfPosiciones={props.listOfPosiciones} 
              organigrama={props.organigrama} 
              delete={props.delete}                 
            />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default CompetenciaPosicionesList;